import {
  DeliveryService,
  ExtendedWarranty,
} from "../../../types/prodcatBaseTypes";
import { VariantServices } from "../../../types/types";

export type CommonServiceProps = {
  selected: boolean;
  value: number;
  display:
    | ExtendedWarranty["price"]["display"]
    | DeliveryService["price"]["display"];
  skuId:
    | ExtendedWarranty["aliases"]["skuId"]
    | DeliveryService["aliases"]["dmsId"];
  serviceType: ExtendedWarranty["__typename"] | DeliveryService["__typename"];
};

export type TransformedDeliveryService = Pick<
  DeliveryService,
  "id" | "title" | "description"
> &
  CommonServiceProps;

export type TransformedExtendedWarranty = Omit<
  ExtendedWarranty,
  "price" | "__typename" | "aliases" | "automaticallyIncluded" | "displayCode"
> &
  CommonServiceProps;

export const mappedServices = (services: VariantServices) => {
  if (!services) return [];

  const addBlankLinkTargets = (html: string) => {
    const parser = new DOMParser();
    const document = parser.parseFromString(html, "text/html");
    const links = document.querySelectorAll("a");

    for (const link of links) {
      if (link.href && !link.target) link.setAttribute("target", "_blank");
    }

    return document.body.innerHTML;
  };

  return services
    .filter(
      (service) =>
        !!service.__typename &&
        ["DeliveryService", "ExtendedWarranty"].includes(service.__typename),
    )
    .map((service) => {
      const { __typename: serviceType, title, id } = service;

      if (serviceType === "ExtendedWarranty") {
        const {
          confirmation,
          policyDetail,
          purchaseDescription,
          tooltip,
          aliases: { skuId },
          price: { display, value },
        } = service;

        return {
          id,
          title,
          display,
          value: parseFloat(value),
          selected: false,
          skuId: skuId,
          tooltip: addBlankLinkTargets(tooltip),
          purchaseDescription,
          policyDetail: addBlankLinkTargets(policyDetail),
          confirmation: addBlankLinkTargets(confirmation),
          serviceType,
        } as TransformedExtendedWarranty;
      }

      const {
        description,
        price: { display, value },
        aliases: { dmsId },
      } = service as DeliveryService;

      return {
        id,
        title,
        description,
        display,
        value: parseFloat(value),
        selected: false,
        skuId: `DMS${dmsId}`,
        serviceType,
      } as TransformedDeliveryService;
    });
};
